import { Directive, ElementRef, AfterViewInit } from '@angular/core';
import { MatFormFieldControl, MatFormField } from '@angular/material';
import { OgCustomInput } from './OgCustomInput';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[ogDefaultFormErrors]'
})
export class DefaultFormErrorsDirective implements AfterViewInit {
  ngControl: NgControl;
  constructor(private formField: MatFormField, private el: ElementRef) {

  }

  ngAfterViewInit(): void {
    this.ngControl = this.formField._control.ngControl;
    this.ngControl.valueChanges.subscribe(() => {
      if (!this.ngControl.valid) {
        this.el.nativeElement.innerHTML = this.firstError();
      }
    });
  }

  firstError() {
    let errorMessage = null;
    if (!this.ngControl.valid) {
      for (const error in this.ngControl.errors) {
        if (this.ngControl.errors.hasOwnProperty(error) && !errorMessage) {
          errorMessage = this.errorMessage(error, this.ngControl.errors[error]);
        }
      }
      return errorMessage;
    }
    return false;
  }

  invalid () {
    if (!this.ngControl) {
      return false;
    }
    return !this.ngControl.valid && (this.ngControl.dirty || this.ngControl.touched);
  }

  errorMessage(errorType, e) {
    const error = e || {};
    const defaultErrors = {
      required: 'Ã© obrigatÃ³rio',
      email: 'precisa ser um e-mail vÃ¡lido',
      maxlength: `deve conter no mÃ¡ximo ${error.requiredLength} caracteres`,
      minlength: `deve conter no mÃ­nimo ${error.requiredLength} caracteres`,
      dateFormat: `deve ser uma data vÃ¡lida DD/MM/AAAA`,
      horario: `deve ser um horÃ¡rio vÃ¡lido (HH:MM)`
    };
    if (!defaultErrors[errorType]) {
      return 'Verifique os dados informados';
    }
    return `<b>${this.errorLabel()}</b> ${defaultErrors[errorType]}`;
  }
  errorLabel() {
    const placeholder = this.formField._control.placeholder;
    if (placeholder) {
      const label = placeholder.toLocaleUpperCase();
      return `"${label}"`;
    }
    return 'Este campo';
  }

}
